import { DestroyRef, Directive, ElementRef, OnInit, inject } from '@angular/core';

import { BsDropdownState } from 'ngx-bootstrap/dropdown';

import Util from '@ace/util';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Directive({ selector: '.navbar-dropdown[dropdown]' })
export class NgAceNavbarDropdown implements OnInit {
  private readonly el = inject(ElementRef);
  private readonly bsDropdownState = inject(BsDropdownState);
  private readonly destroyRef = inject(DestroyRef);

  element: HTMLElement;

  constructor() {
    this.element = this.el.nativeElement;
  }

  ngOnInit(): void {
    this.bsDropdownState.isOpenChange.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((isOpen: boolean) => {
      // when a .dropdown is opened, add .navbar-open to increase z-index, so that dropdowns go above 'asides', etc
      if (isOpen) {
        const navbar = Util.closest(this.element, '.navbar');
        if (!navbar) return;
        if (this.element.classList.contains('backdrop-shown')) navbar.classList.add('navbar-modal');
        else navbar.classList.add('navbar-open');
      } else {
        const navbar = Util.closest(this.element, '.navbar');
        if (!navbar) return;
        navbar.classList.remove('navbar-open');
        navbar.classList.remove('navbar-modal');
      }
    });
  }
}
